import React, { useState, useEffect } from 'react';
import { Entrega, FormData } from './types';
import { api, API_ROUTERS } from '../../../services/api';
import { Entregador } from '../../Cadastros/Notas/types';
import RelatoriosEntregasContent from './view';

const RelatoriosEntregasContainer: React.FC = () => {
  const [entregas, setEntregas] = useState<Entrega[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState<FormData>({
    dataInicio: '',
    dataFim: '',
    usuario: null
  });
  const [selectedEntrega, setSelectedEntrega] = useState<Entrega | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [entregadores, setEntregadores] = useState<Entregador[]>([]);

  useEffect(() => {
    const fetchEntregadores = async () => {
      try {
        const entregadores = api.utils.trataResponseArray(
          await api.get(API_ROUTERS.ENTREGADORES)
        ) as Entregador[]
        setEntregadores(entregadores);
      } catch (err) {
        console.error('Erro ao buscar entregadores:', err);
      }
    };

    fetchEntregadores();
  }, []);

  const handleInputChange = (field: keyof FormData, value: string | number | null) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = async () => {
    if (!formData.dataInicio || !formData.dataFim) {
      setError('Por favor, selecione as datas de início e fim');
      return;
    }

    setLoading(true);
    setError('');
    setEntregas([]);

    try {
      let url = `${API_ROUTERS.RELATORIO}?dataInicio=${formData.dataInicio}&dataFim=${formData.dataFim}`;

      if (formData.usuario) {
        url += `&usuario=${formData.usuario}`;
      }

      const response = await api.get(url);

      if(response){
        setEntregas(response);
      }else{
        setEntregas([]);
      }

    } catch (err: any) {
      console.error('Erro ao buscar relatório:', err);
      setError(err.response?.data?.message || 'Erro ao buscar relatório de entregas');
      setEntregas([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      dataInicio: '',
      dataFim: '',
      usuario: null
    });
    setEntregas([]);
    setError('');
  };

  const handleViewImage = (entrega: Entrega) => {
    setSelectedEntrega(entrega);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedEntrega(null);
  };

  return (
    <RelatoriosEntregasContent
      entregas={entregas}
      loading={loading}
      error={error}
      formData={formData}
      selectedEntrega={selectedEntrega}
      showModal={showModal}
      entregadores={entregadores}
      handleInputChange={handleInputChange}
      handleSearch={handleSearch}
      handleClear={handleClear}
      handleViewImage={handleViewImage}
      closeModal={closeModal}
    />
  );
};

export default RelatoriosEntregasContainer;
